// extracted by mini-css-extract-plugin
export var content = "_os-1";
export var fullScreen = "_os-0";